import type ReactDOMServer from 'react-dom/server';

import { createSingleton } from '@luna/utils';

const { get, set } = createSingleton<typeof ReactDOMServer | undefined>();

export function getReactDomServer(): typeof ReactDOMServer | undefined {
    return get();
}

export function setReactDomServer(server: typeof ReactDOMServer): void {
    set(server);
}
